const ToastBox = ({ message, type = "info", onClose }) => {
  const bgColors = {
    success: "bg-green-500",
    error: "bg-red-500",
    info: "bg-blue-500",
    warning: "bg-yellow-500",
  };

  return (
    <div
      className={`px-4 py-3 rounded-lg shadow-lg text-white text-sm flex items-center justify-between gap-3 ${bgColors[type]}`}
    >
      <span className="whitespace-pre-line text-left">{message}</span>
      <button
        onClick={onClose}
        className="text-white font-bold hover:opacity-75"
      >
        ×
      </button>
    </div>
  );
};

export default ToastBox;
